import React, { useState, useEffect } from 'react';
import landingPageAPI from '../../services/api';
import './HowItWorks.css';
import { useLoading } from '../../contexts/LoadingContext';

const HowItWorks = () => {
  const { markComponentLoaded } = useLoading();
  const [steps, setSteps] = useState([]);
  const [title, setTitle] = useState('How It Works');
  const [subtitle, setSubtitle] = useState('Simple setup, powerful results');

  useEffect(() => {
    fetchSteps();
  }, []);

  const fetchSteps = async () => {
    try {
      const response = await landingPageAPI.getAllContent();
      if (response.data.status === 'success') {
        const sections = response.data.data.sections || [];
        const aboutSection = sections.find(s => s.section_key === 'about');

        if (aboutSection && aboutSection.content) {
          const titleContent = aboutSection.content.find(c => c.content_key === 'about_title');
          const subtitleContent = aboutSection.content.find(c => c.content_key === 'about_subtitle');

          if (titleContent) setTitle(titleContent.content_value);
          if (subtitleContent) setSubtitle(subtitleContent.content_value);

          // Extract steps - discover every about_step_N_title/_desc pair
          // present rather than assuming a fixed count of 4, so additional
          // steps added via the admin content manager actually show up.
          const stepNumbers = new Set();
          aboutSection.content.forEach((c) => {
            const match = c.content_key.match(/^about_step_(\d+)_(title|desc)$/);
            if (match) stepNumbers.add(Number(match[1]));
          });

          const stepsData = Array.from(stepNumbers)
            .sort((a, b) => a - b)
            .map((i) => {
              const stepTitle = aboutSection.content.find(c => c.content_key === `about_step_${i}_title`);
              const stepDesc = aboutSection.content.find(c => c.content_key === `about_step_${i}_desc`);
              return stepTitle && stepDesc
                ? { number: i, title: stepTitle.content_value, description: stepDesc.content_value }
                : null;
            })
            .filter(Boolean);

          setSteps(stepsData);
        }
      }
    } catch (error) {
      console.error('Failed to fetch steps:', error);
    } finally {
      markComponentLoaded('HowItWorks');
    }
  };

  return (
    <section className="how-it-works" id="how-it-works">
      <div className="container">
        <div className="section-title">
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>
        <div className="steps">
          {steps.map((step) => (
            <div key={step.number} className="step">
              <div className="step-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;